import { Component, OnInit } from '@angular/core';

import { SignerService } from '../../services/signer/signer.service';

@Component({
  selector: 'app-session-timed-out-page',
  templateUrl: './session-timed-out-page.component.html',
  styleUrls: ['./session-timed-out-page.component.scss'],
})
export class SessionTimedOutPageComponent implements OnInit {
  //context;

  constructor(private signerService: SignerService) {}

  ngOnInit() {
    //this.context = {
    //    title: "Your session has timed out.",
    //    description: "To return to your session, click on the button in the original email that initiated the signing process.",
    //    svg: {
    //        xlinkHref: "#dialog-timeout",
    //        xlinkHrefDisabled: ""
    //    },
    //    button:
    //    {
    //        text: "Close"
    //    }
    //}
  }

  onClose() {
    this.signerService.finish();
  }
}
